import { c as _c } from "react/compiler-runtime";
import * as seadn from "@opensea/seadn";
import { CenterAligned, classNames, Flex } from "@opensea/ui-kit";
import { Image as ImageIcon } from "@opensea/ui-kit/icons";
import NextImage from "next/image";
import { blurhashToBase64 } from "./blurhash";
export function Image(t0) {
  const $ = _c(56);
  let blurDataURLProp;
  let blurhash;
  let boost;
  let fit;
  let format;
  let frameTime;
  let original;
  let rest;
  let src;
  let t1;
  let unoptimized;
  if ($[0] !== t0) {
    ({
      original,
      src,
      unoptimized,
      blurhash,
      alt: t1,
      fit,
      frameTime,
      boost,
      format,
      blurDataURL: blurDataURLProp,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = blurDataURLProp;
    $[2] = blurhash;
    $[3] = boost;
    $[4] = fit;
    $[5] = format;
    $[6] = frameTime;
    $[7] = original;
    $[8] = rest;
    $[9] = src;
    $[10] = t1;
    $[11] = unoptimized;
  } else {
    blurDataURLProp = $[1];
    blurhash = $[2];
    boost = $[3];
    fit = $[4];
    format = $[5];
    frameTime = $[6];
    original = $[7];
    rest = $[8];
    src = $[9];
    t1 = $[10];
    unoptimized = $[11];
  }
  const alt = t1 === undefined ? "" : t1;
  if (!src) {
    const height = Number(rest.height?.toString().replace("px", "") ?? 0);
    const width = Number(rest.width?.toString().replace("px", "") ?? 0);
    const smallestSide = Math.min(height, width);
    const size = smallestSide <= 100 ? "50%" : "20%";
    let t2;
    if ($[12] !== rest.className) {
      t2 = classNames("relative bg-bg-additional-2", rest.className);
      $[12] = rest.className;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = classNames("absolute top-0 left-0 size-full");
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== size) {
      t4 = <CenterAligned className={t3}><ImageIcon size={size} /></CenterAligned>;
      $[15] = size;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    let t5;
    if ($[17] !== alt || $[18] !== rest || $[19] !== unoptimized) {
      t5 = <NextImage {...rest} alt={alt} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" unoptimized={unoptimized} />;
      $[17] = alt;
      $[18] = rest;
      $[19] = unoptimized;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    let t6;
    if ($[21] !== t2 || $[22] !== t4 || $[23] !== t5) {
      t6 = <Flex className={t2}>{t4}{t5}</Flex>;
      $[21] = t2;
      $[22] = t4;
      $[23] = t5;
      $[24] = t6;
    } else {
      t6 = $[24];
    }
    return t6;
  }
  let t2;
  if ($[25] !== blurDataURLProp || $[26] !== blurhash) {
    t2 = blurDataURLProp ?? (blurhash ? blurhashToBase64(blurhash) : undefined);
    $[25] = blurDataURLProp;
    $[26] = blurhash;
    $[27] = t2;
  } else {
    t2 = $[27];
  }
  const blurDataURL = t2;
  const placeholder = blurDataURL ? "blur" : undefined;
  if (original !== true && (typeof src !== "string" || !(rest.height || rest.width))) {
    let t3;
    if ($[28] !== alt || $[29] !== blurDataURL || $[30] !== placeholder || $[31] !== rest || $[32] !== src || $[33] !== unoptimized) {
      t3 = <NextImage {...rest} alt={alt} blurDataURL={blurDataURL} placeholder={placeholder} src={src} unoptimized={unoptimized} />;
      $[28] = alt;
      $[29] = blurDataURL;
      $[30] = placeholder;
      $[31] = rest;
      $[32] = src;
      $[33] = unoptimized;
      $[34] = t3;
    } else {
      t3 = $[34];
    }
    return t3;
  }
  let t3;
  if ($[35] !== boost || $[36] !== fit || $[37] !== format || $[38] !== frameTime || $[39] !== original || $[40] !== rest.height || $[41] !== rest.quality || $[42] !== rest.width || $[43] !== src) {
    t3 = original ? seadn.originalURL(src) : seadn.optimize(src, {
      height: rest.height,
      width: rest.width,
      quality: rest.quality,
      fit,
      frameTime,
      boost,
      format
    });
    $[35] = boost;
    $[36] = fit;
    $[37] = format;
    $[38] = frameTime;
    $[39] = original;
    $[40] = rest.height;
    $[41] = rest.quality;
    $[42] = rest.width;
    $[43] = src;
    $[44] = t3;
  } else {
    t3 = $[44];
  }
  const resized = t3;
  let t4;
  if ($[45] !== rest.height || $[46] !== rest.width) {
    t4 = rest.height && rest.width ? {
      height: rest.height,
      width: rest.width
    } : {
      fill: true,
      width: undefined,
      height: undefined
    };
    $[45] = rest.height;
    $[46] = rest.width;
    $[47] = t4;
  } else {
    t4 = $[47];
  }
  const t5 = unoptimized ?? true;
  let t6;
  if ($[48] !== alt || $[49] !== blurDataURL || $[50] !== placeholder || $[51] !== resized || $[52] !== rest || $[53] !== t4 || $[54] !== t5) {
    t6 = <NextImage {...rest} {...t4} alt={alt} blurDataURL={blurDataURL} placeholder={placeholder} src={resized} unoptimized={t5} />;
    $[48] = alt;
    $[49] = blurDataURL;
    $[50] = placeholder;
    $[51] = resized;
    $[52] = rest;
    $[53] = t4;
    $[54] = t5;
    $[55] = t6;
  } else {
    t6 = $[55];
  }
  return t6;
}